import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=5ea4f6ba&scoped=true"
import script from "./Merchant.vue?vue&type=script&lang=js"
export * from "./Merchant.vue?vue&type=script&lang=js"
import style0 from "./Merchant.vue?vue&type=style&index=0&id=5ea4f6ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4f6ba",
  null
  
)

export default component.exports